import React, { Fragment, useEffect, useState } from "react";
import UpgradeMessageDialog from "./UpgradeMessageDialog";

const SubscriptionUpgrade = (props: any) => {
  const { fromSideNav } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => {
    setOpenDialog(false);
  };
  return (
    <Fragment>
      <div className="px-1.5 py-0.5 bg-blue-400 rounded-md border border-blue-400 justify-center items-center gap-2.5 flex">
        <div className="justify-start items-center gap-1.5 flex">
          <div
            className="text-indigo-50 text-xs font-medium font-['Proxima Nova']"
            onClick={() => {
              !fromSideNav && setOpenDialog(true);
            }}
          >
            Upgrade
          </div>
        </div>
      </div>
      <UpgradeMessageDialog open={openDialog} onClose={handleClose} />
    </Fragment>
  );
};

export default SubscriptionUpgrade;
